import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDPSState } from '@shared/models/prospect-data-models.interface';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProspectService {
  constructor(private http: HttpClient) {}

  callDPSNode(): Observable<IDPSState> {
    return this.http.get<IDPSState>(`secure/prospect`);
  }
}
